import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Checkbox, Dropdown, Space, Table, Tag } from "antd";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const PendingApprovalCollectTimeTable = ({
  modalFlag = true,
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onReturn = () => { },
  onApprove = () => { },
  onReject = () => { },
  onCancel = () => { },
  onStatus = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">{t('req_id.req_id')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      visible: true,
    },
    {
      title: <div className="text-table">{t('name-surname')}</div>,
      dataIndex: "employee",
      key: "employee",
      visible: true,
      render: (text, record) => {

        return i18n.language === 'en' ? <span>{record?.employee?.nameAndSurnameEn}</span> : <span>{record?.employee?.nameAndSurname}</span>
      }
    },


    {
      title: <div className="text-table">{t('pending_approval_collect_time.label.collect_date')}</div>,
      dataIndex: "dateToCollect",
      key: "dateToCollect",
      visible: true,
    },
    {
      title: <div className="text-table">{t('start-date')}</div>,
      dataIndex: "startDate",
      key: "startDate",
      visible: true,
    },
    {
      title: <div className="text-table">{t('end-date')}</div>,
      dataIndex: "endDate",
      key: "endDate",
      visible: true,
    },
    {
      title: <div className="text-table">{t('leave_type.label.duration')}</div>,
      dataIndex: "totalDuration",
      key: "totalDuration",
      visible: true,
      render: (_, record) => {
        if (record.durationType === 'ALLDAY') {
          return i18n.language === 'en' ? record?.totalDuration + " Day" : record?.totalDuration + " วัน"
        } else {
          return i18n.language === 'en' ? record?.totalDurationHour + "H " + record?.totalDurationMinute + "M" : record?.totalDurationHour + " ชม. " + record?.totalDurationMinute + " นาที"
        }
      }
    },
    {
      title: <div className="text-table">{t('description.description')}</div>,
      dataIndex: "description",
      key: "description",
      visible: true,
    },
    {
      title: <div className="text-table">{t('status.status')}</div>,
      dataIndex: "approveStatus",
      key: "approveStatus",
      align: "center",
      visible: true,
      render: (text, record) => {
        let language = i18n.language == "en" ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
        // let tagColor = "green";
        // if (record?.approveStatusEn === "Pending") {
        //   tagColor = "blue";
        // } else if (record?.approveStatusEn === "Rejected" || record?.approveStatusEn === "Cancelled") {
        //   tagColor = "red";
        // }
        // return i18n.language === 'en' ? <Tag color={tagColor}>{record?.approveStatusEn}</Tag> : <Tag color={tagColor}>{record?.approveStatus}</Tag>
      },
    },
    {
      title: "",
      key: "action",
      align: "center",
      visible: modalFlag,
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "2",
                  onClick: () => onApprove({
                    ...record,
                    table: "PendingApprovalCollectTimeTable"
                  }),
                  label: `${t("action.approve")}`,
                  icon: (
                    <CheckOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "1",
                  onClick: () => onReject({
                    ...record,
                    table: "PendingApprovalCollectTimeTable"
                  }),
                  label: `${t("action.reject")}`,
                  icon: (
                    <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },

  ];

  const visibleColumns = columns.filter((col) => col.visible);


  return (
    <TableAntd
      loading={isLoading}
      style={{ backgroundColor: "white", width: "100%" }}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={visibleColumns}
      onChange={onChange}
    />
  );
};

export default PendingApprovalCollectTimeTable;
